import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import ScrollReveal from "../../utils/ScrollReveal";
import Seo from "../../seo/Seo";
import { organizationJsonLd } from "../../seo/defaults";

// import sections
import HomeTopImg from "../../components/sections/home/HomeTopImg";
import WhatWeDo from "../../components/sections/home/WhatWeDo";
import OurServices from "../../components/sections/home/OurServices";
import WellArchitected from "../../components/sections/home/WellArchitected";
import OurWorks from "../../components/sections/home/OurWorks";
import OurCustomers from "../../components/sections/home/OurCustomers";

const trackPage = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

const Home = () => {
  const childRef = useRef();
  let location = useLocation();
  const page = location.pathname;

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    document.body.classList.add("is-loaded");
    childRef.current.init();
    trackPage(page);
    // Support deep-links to in-page sections (e.g. /#well-architected-review).
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
        return;
      }
    }
    goToTop();
  }, [location, page]);

  return (
    <>
      <Seo
        title="AWS Consulting & Data Platforms in Thailand"
        description="Trade Square Co., Ltd. — AWS consulting, data platforms, and custom software delivery based in Bangkok, Thailand."
        canonical="/"
        jsonLd={organizationJsonLd()}
      />
    <ScrollReveal
      ref={childRef}
      children={() => (
        <React.Fragment>
          {/* {page} */}
          <div className="bg-top" />
          <HomeTopImg id="HomeTopImg" />
          <WhatWeDo id="WhatWeDo" topDivider />
          <OurServices id="OurServices" topDivider />
          <WellArchitected id="well-architected-review" topDivider />
          <OurWorks id="OurWorks" topDivider />
          <OurCustomers id="OurCustomers" topDivider />
          <div className="bg-bottom" />
          {/* <HowWeWork id="HowWeWork" />
          <WhatWeValue
            invertMobile
            topDivider
            className="illustration-section-02"
            id="WhatWeValue"
          />
          <ContactUs id="ContactUs" /> */}
          {/* <Cta split /> */}
        </React.Fragment>
      )}
    />
    </>
  );
};

export default Home;
